import { createAction } from '@reduxjs/toolkit';

import { AgentClientPatch } from '../../modules/b2b/api';

export const fetchB2BClientsAction = createAction<
  | {
      query?: string;
      page?: number;
      perPage?: number;
    }
  | undefined
>('FETCH_B2B_CLIENTS');

export const selectB2BClientAction = createAction<{ id: string }>(
  'SELECT_B2B_CLIENT'
);

export const updateB2BClientAction = createAction<{
  id: string;
  client: AgentClientPatch;
}>('UPDATE_B2B_CLIENT');
